import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ParishConfigService } from '../services/parishconfig.service';

export const parishGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const parishService = inject(ParishConfigService);
  const router = inject(Router);

  let parishConfig = parishService.getCurrentParishConfig();

  if (parishConfig && parishConfig?.ParishId > 0) {
    return true;
  }

  if (state.url !== '/companylist') {
    return router.createUrlTree(['/companylist']);
  } else {
    return false;
  }
};